var _a;
import { __assign } from "tslib";
import { STREAM__WITH_PAGINATION__INITIALIZE, STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE, STREAM__WITH_PAGINATION__GO_TO_PREV_PAGE, STREAM__WITH_PAGINATION__FETCH, STREAM__WITH_PAGINATION__FETCH_SUCCESS, } from './actions';
import { handleInitAction, handleFetchAction, handleFetchSuccessAction, commonActionHandlers, } from '../base/actionHandlers';
import { StreamType } from '../types';
import { defaultStreamState } from '../constants';
var actionHandlers = __assign((_a = {}, _a[STREAM__WITH_PAGINATION__INITIALIZE] = function (streamState, action) {
    var _a = action.page, page = _a === void 0 ? 0 : _a;
    return __assign(__assign({}, handleInitAction(streamState, action)), { page: page });
}, _a[STREAM__WITH_PAGINATION__GO_TO_PREV_PAGE] = function (streamState, action) {
    return __assign(__assign({}, streamState), { page: Math.max((streamState.page || 0) - 1, 0) });
}, _a[STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE] = function (streamState, action) {
    return __assign(__assign({}, streamState), { page: (streamState.page || 0) + 1 });
}, _a[STREAM__WITH_PAGINATION__FETCH] = function (streamState) {
    return handleFetchAction(streamState);
}, _a[STREAM__WITH_PAGINATION__FETCH_SUCCESS] = function (streamState, action) { return handleFetchSuccessAction(streamState, action); }, _a), commonActionHandlers);
var reducer = function (streamState, action) {
    if (streamState === void 0) { streamState = __assign(__assign({}, defaultStreamState), { streamType: StreamType.WITH_PAGINATION }); }
    var handler = actionHandlers[action.type];
    return (handler && handler(streamState, action)) || streamState;
};
export default reducer;
//# sourceMappingURL=reducer.js.map